import { useGlobalization, useSettings } from '@innovyze/stylovyze';
import React from 'react';
import ComponentStatusControls from './ComponentStatusControls';
import { useHeartBeatStatusChecker } from '@Hooks';

const ComponentStatusControlsSmart = () => {
	const { t } = useGlobalization();
	const {
		companySettings: { dateFormat: df, hourCycle12: hc, timeZoneIANA },
	} = useSettings();
	const {
		handleGetHeartBeatStatus,
		handleGetHeartBeatStatusStop,
		heartBeatSyncAtTs,
		heartBeatFirstPoll,
	} = useHeartBeatStatusChecker();

	const handleClickOnSynchButton = () => {
		handleGetHeartBeatStatusStop();
		handleGetHeartBeatStatus();
	};

	const dateLabel = `${t('Last synched')} [${timeZoneIANA}]`;
	const syncButtonText = `${t('Sync')}`;
	const format = `${df} - ${hc ? 'hh' : 'HH'}:mm:ss ${hc ? 'A' : ''}`;

	return (
		<ComponentStatusControls
			clickOnSynchButtonHandler={handleClickOnSynchButton}
			lastSynchAtTs={heartBeatSyncAtTs}
			dateLabel={dateLabel}
			syncButtonText={syncButtonText}
			format={format}
			timeZoneIANA={timeZoneIANA}
			disabledSync={heartBeatFirstPoll}
		/>
	);
};

export default ComponentStatusControlsSmart;
